import { from, of } from 'rxjs';
import { AuthHttp } from '@common/services';
import { map, catchError } from 'rxjs/operators';
import { openNotification } from '@common/helpers';
import { getRequestParams } from '@helpers';

/**
 * GET /api/cost-centers
 * Get cost center list
 */
export function getCostCentersList(params) {
  const requestParams = getRequestParams(params);
  const url = `/cost-centers/summary?${requestParams}`;
  return from(AuthHttp.get(url)).pipe(
    map(({ data }) => {
      return { data: data.content, count: data.totalElements };
    }),
    catchError(error => {
      openNotification(
        'error',
        'Occurred error when load cost center list from server!'
      );
      return of({ data: [], count: 0 });
    })
  );
}

/**
 * GET /api/companies
 * Get company list
 */
export function getCompanyOptions() {
  const url = 'companies';
  return from(AuthHttp.get(url)).pipe(
    map((res) => {
      if (res.data && !res.data.length) {
        openNotification(
          'error',
          'Company list is empty!'
        );
        return [];
      }
      return res.data.map(({ id, name }) => ({ id, name }));
    }),
    catchError(e => {
      openNotification(
        'error',
        'Occurred error when load cost center list from server!'
      );
      return of([]);
    })
  );
}

/**
 * GET /api/cost-centers/{id}
 * Get cost center details
 * @param id ID of cost center (Required)
 */
export function getCostCenterDetails(id) {
  const url = `/cost-centers/${id}`;
  return from(AuthHttp.get(url)).pipe(
    map(({ data }) => {
      return data;
    }),
    catchError(error => {
      openNotification(
        'error',
        'Occurred error when load business unit list from server!'
      );
      return of({ data: [], count: 0 });
    })
  );
}

/**
 * Update /api/cost-center/update/{id}.
 *
 * @param id cost center id (Required)
 */
export function updateCostCenter(id, params) {
  const url = `/cost-centers/${id}`;
  return from(AuthHttp.patch(url, params)).pipe(
    catchError(e => {
      const messages = e.response.data.messages;
      openNotification(
        'error',
        messages ? messages[0].message : 'Occurred error when update cost center from server!'
      );
      return of({});
    })
  );
}

/**
 * DELETE /cost-centers
 * @param ids id of cost center (Required)
 */
export function deleteCostCenters(ids) {
  const url = `/cost-centers?listCostCenterId=${ids}`;
  return from(AuthHttp.delete(url, {})).pipe(
    catchError(e => {
      const messages = e.response.data.messages;
      openNotification(
        'error',
        messages ? messages[0].message : 'Occurred error when delete cost center from server!'
      );
      return of({});
    })
  );
}

/**
 * DELETE /cost-centers
 * @param ids id of cost center (Required)
 */
export function getAllByCompanyProfile(companyId) {
  const url = `/cost-centers?companyId=${companyId}`;
  return from(
      AuthHttp.get(url).catch((e) => {
        openNotification("error", "Get user's profile error");
      })
    );
}


/**
 * POST /cost-centers
 * Add new cost center
 * @param
 */
export function addCostCenter(params) {
  return from(AuthHttp.post('/cost-centers', params))
    .pipe(
      catchError(e => {
        openNotification(
          'error',
          e.response.data.messages ? e.response.data.messages[0].message : 'Occurred error when create business unit!'
        );
        return of({});
      })
    );
}
